import * as type from '../types'


export const retrieveUserDetails = payload => {
    return{
        type: type.REQUEST_USER_DETAILS,
        payload: payload
    }
}

export const setUserDetails = payload => {
    return{
        type: type.SET_USER_DETAILS,
        user: payload
    }
}

export const flushDetails = () => {
    return{
        type: type.REMOVE_USER_DETAILS,
    }
}

export const requestUpdateUserInfo = payload => {
    return{
        type: type.REQUEST_UPDATE_USER_INFO,
        details: payload
    }
}

export const resetUpdateUserInfo = () => {
    return{
        type: type.RESET_UPDATE_USER_INFO
    }
}

export const retrieveFullName = payload => {
    return{
        type: type.REQUEST_USER_FULL_NAME,
        payload: payload
    }
}

export const resetFullName = () => {
    return{
        type: type.RESET_USER_FULL_NAME
    }
}

export const retrieveUserImage = payload => {
    return{
        type: type.REQUEST_USER_IMAGE,
        payload: payload
    }
}

export const resetUserImage = () => {
    return{
        type: type.RESET_USER_IMAGE
    }
}

export const requestUpdateUserGeneral = payload => {
    return{
        type: type.REQUEST_UPDATE_USER_GENERAL,
        payload: payload
    }
}

export const resetUpdateUserGeneral = () => {
    return{
        type: type.RESET_UPDATE_USER_GENERAL
    }
}

export const requestUpdateUserPassword = payload => {
    return{
        type: type.REQUEST_UPDATE_USER_PASSWORD,
        details: payload
    }
}

export const resetUpdateUserPassword = () => {
    return{
        type: type.RESET_UPDATE_USER_PASSWORD
    }
}

export const retrieveUserLogins = payload => {
    return{
        type: type.REQUEST_USER_LOGINS,
        payload: payload
    }
}

export const setUserLogins = payload => {
    return{
        type: type.SET_USER_LOGINS,
        logins: payload
    }
}

export const removeUserLogins = payload => {
    return{
        type: type.REMOVE_USER_LOGINS,
        logins: payload
    }
}

export const requestUpdateUserImage = payload => {
    return{
        type: type.REQUEST_UPDATE_USER_IMAGE,
        details: payload
    }
}

export const resetUpdateUserImage = () => {
    return{
        type: type.RESET_UPDATE_USER_IMAGE
    }
}

export const requestDeleteUserImage = payload => {
    return{
        type: type.REQUEST_DELETE_USER_IMAGE,
        details: payload
    }
}

export const resetDeleteUserImage = () => {
    return{
        type: type.RESET_DELETE_USER_IMAGE
    }
}

export const retrieveUserCompanies = payload => {
    return{
        type: type.REQUEST_USER_COMPANIES,
        payload: payload
    }
}

export const requestAcceptInvitation = payload => {
    return{
        type: type.REQUEST_ACCEPT_INVITATION,
        payload: payload
    }
}

export const resetAcceptInvitation = () => {
    return{
        type: type.RESET_ACCEPT_INVITATION
    }
}

export const requestRejectInvitation = payload => {
    return{
        type: type.REQUEST_REJECT_INVITATION,
        payload: payload
    }
}

export const resetRejectInvitation = () => {
    return{
        type: type.RESET_REJECT_INVITATION
    }
}

export const requestUpdateUnseenNotifications = payload => {
    return{
        type: type.REQUEST_UPDATE_UNSEEN_NOTIFICATIONS,
        payload: payload
    }
}

export const resetUpdateUnseenNotifications = () => {
    return{
        type: type.RESET_UPDATE_UNSEEN_NOTIFICATIONS
    }
}

export const requestFetchNotifications = payload => {
    return{
        type: type.REQUEST_FETCH_NOTIFICATIONS,
        payload: payload
    }
}

export const resetFetchNotifications = () => {
    return{
        type: type.RESET_FETCH_NOTIFICATIONS
    }
}